import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { BackToTopButton } from './components/BackToTopButton';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { HomePage } from './pages/HomePage';
import { BusinessSchema } from './components/BusinessSchema';
export function App() {
  // Add smooth scrolling for anchor links
  useEffect(() => {
    const handleLinkClick = e => {
      const href = e.target.getAttribute('href');
      if (href && href.startsWith('#') && href.length > 1) {
        // Only handle actual anchor links
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      link.addEventListener('click', handleLinkClick);
    });
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleLinkClick);
      });
    };
  }, []);
  return <HelmetProvider data-id="element-0">
      <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-1">
        <BusinessSchema data-id="element-2" />
        <BrowserRouter data-id="element-3">
          <Header data-id="element-4" />
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/blog" element={<BlogPage data-id="element-9" />} data-id="element-8" />
            <Route path="/blog/:id" element={<BlogPostPage data-id="element-11" />} data-id="element-10" />
            {/* Redirect to home for unknown routes, but don't catch static files */}
            <Route path="*" element={<HomePage data-id="element-13" />} data-id="element-12" />
          </Routes>
          <Footer data-id="element-14" />
          <BackToTopButton data-id="element-15" />
        </BrowserRouter>
      </div>
    </HelmetProvider>;
}